/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SmsCampaignStatus {
    WAITING_FOR_EXECUTION = 'WaitingForExecution',
    EXECUTED = 'Executed',
    FINISHED = 'Finished',
    WAITING_FOR_ADMIN_REVIEW = 'WaitingForAdminReview',
    ADMIN_REJECTED = 'AdminRejected',
}
